import {Tabs} from "@material-ui/core"
import React from 'react'
import {theme} from "../../../shared/theme";
import TabLabel from "./TabLabel";
import Tab from '@material-ui/core/Tab';
import {colors} from "../../../shared/colors";
import TabPanel from "./TabPanel";
import PropTypes from "prop-types";

const CustomTabs = (props) => {
    const tabsStyle = {marginTop: theme.spacing(2)}
    const tabsIndicatorProps = {style: {height: "8px", backgroundColor: colors.primary.main}}

    const renderTabs = props.tabs.map((t, idx) => {
        return (
            <Tab key={`tab-${idx}`}
                 label={<TabLabel title={t.title} subtitle={t.subtitle}/>}/>
        )
    });

    const renderTabPanels = props.tabs.map((t, idx) => {
        return (<TabPanel value={props.selectedTab} key={`tab-panel-${idx}`} index={idx}>
            {t.component}
        </TabPanel>)
    });

    return (
        <React.Fragment>
            <Tabs variant="scrollable"
                  style={tabsStyle}
                  TabIndicatorProps={tabsIndicatorProps}
                  value={props.selectedTab}
                  onChange={props.handleTabChange}
                  aria-label="Custom tabs">
                {renderTabs}
            </Tabs>
            {renderTabPanels}
        </React.Fragment>
    )
};

CustomTabs.propTypes = {
    tabs: PropTypes.array.isRequired,
    handleTabChange: PropTypes.func.isRequired,
    selectedTab: PropTypes.number.isRequired
}

export default CustomTabs;
